var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVifly2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 26,
    viewBox: "0 0 51 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45682 8.26664C0.355683 6.35149 1.01558 3.90631 2.93073 2.80518C4.84588 1.70405 7.29106 2.36394 8.39219 4.27909L17.0805 19.3902C18.1816 21.3054 17.5217 23.7505 15.6066 24.8517C13.6914 25.9528 11.2462 25.2929 10.1451 23.3778L1.45682 8.26664Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3749 11.2331C15.3174 9.23516 17.7012 8.37957 19.6992 9.32211C21.6971 10.2647 22.5527 12.6484 21.6102 14.6464L17.9419 22.4223C16.9993 24.4203 14.6156 25.2759 12.6176 24.3333C10.6196 23.3908 9.76402 21.007 10.7066 19.009L14.3749 11.2331Z",
    fill: "#CBD5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 4.61548C25.9999 6.82462 24.209 8.61548 21.9999 8.61548C19.7908 8.61548 17.9999 6.82462 17.9999 4.61548C17.9999 2.40634 19.7908 0.615479 21.9999 0.615479C24.209 0.615479 25.9999 2.40634 25.9999 4.61548Z",
    fill: "#395BA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.24 11.4648C27.8453 11.4648 27.5147 11.3421 27.248 11.0968C26.992 10.8408 26.864 10.5261 26.864 10.1528C26.864 9.77943 26.992 9.4701 27.248 9.22476C27.5147 8.96876 27.8453 8.84076 28.24 8.84076C28.6347 8.84076 28.96 8.96876 29.216 9.22476C29.4827 9.4701 29.616 9.77943 29.616 10.1528C29.616 10.5261 29.4827 10.8408 29.216 11.0968C28.96 11.3421 28.6347 11.4648 28.24 11.4648ZM29.344 12.5208V21.3848H27.104V12.5208H29.344ZM35.6211 14.3608H34.0691V21.3848H31.7971V14.3608H30.7891V12.5208H31.7971V12.0728C31.7971 10.9848 32.1065 10.1848 32.7251 9.67276C33.3438 9.16077 34.2771 8.92077 35.5251 8.95277V10.8408C34.9811 10.8301 34.6025 10.9208 34.3891 11.1128C34.1758 11.3048 34.0691 11.6514 34.0691 12.1528V12.5208H35.6211V14.3608ZM39.3128 9.54477V21.3848H37.0728V9.54477H39.3128ZM50.0059 12.5208L44.5179 25.5768H42.1339L44.0539 21.1608L40.5019 12.5208H43.0139L45.3019 18.7128L47.6219 12.5208H50.0059Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVifly2);
export default __webpack_public_path__ + "static/media/vifly2.4b7c1350b2f312a6f3e31ae81e2d5923.svg";
export { ForwardRef as ReactComponent };